if (document.getElementById('vue-contact')) {
	// console.log('contact');
	Vue.use(VeeValidate)
	new Vue({
		mixins: [baseMixin, eventHubMixin, apiMixin, MobileValidate],
		el: '#vue-contact',
		data: {
			loading: false,
			form_fields: {
				email: '',
				first_name: '',
				last_name: '',
				civility: '',
				phone: '',
				subject: '',
				message: '',
				accept: '',
				newsletter: ''
			}
		},
		mounted() {},
		created() {
			this.$validator.extend('phone', MobileValidate)
		},
		methods: {
			classesValidation(key) {
				return {
					'is-valid':
						!this.errors.has(key) &&
						this.fields[key] &&
						this.fields[key].valid &&
						this[key] != '' &&
						this.fields[key].validated,
					'is-error': this.errors.has(key)
				}
			},

			submit(event) {
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.loading = true

						let data = this.getFormData(event)

						axios
							.post(ajaxurl, data)
							.then(() => {
								this.clearForm()
								this.eventHub.$emit('notifications:addSuccess')
								this.sendDataToAnalytics()
							})
							.catch((error) => {
								// console.log(error);
							})
							.finally(() => {
								this.loading = false
							})
					} else {
						this.eventHub.$emit('notifications:addError')
					}
				})
			},

			getFormData(event) {
				let data = new FormData(),
					captcha = document.querySelector('.g-recaptcha-response')

				data.append('action', 'sophia_contact')
				data.append('g-recaptcha-response', captcha.value)

				Object.keys(this.form_fields).forEach((key) => {
					data.append(key, this.form_fields[key])
				})

				return data
			},

			clearForm() {
				this.form_fields = {
					email: '',
					first_name: '',
					last_name: '',
					civility: '',
					phone: '',
					subject: '',
					message: '',
					accept: '',
					newsletter: ''
				}

				this.$validator.reset()
			},

			updateFile(event) {
				this.attachement = event.target.files[0]
			},

			sendDataToAnalytics() {
				gtag('event', 'submit', {
					'event_category': 'Demande de contact',
					'event_label': 'Message envoyé par un utilisateur'
				});
			}
		}
	})
}
